import { all, put, call, fork, take } from "redux-saga/effects";
import * as api from "../../utils/api";
import { dailyQuestActions, GET_DAILY_QUEST_REQUEST, ANSWER_DAILY_QUEST_REQUEST } from "./actions";

export function* asyncGetDailyQuest({ payload, resolve, reject }) {
  try {
    const questRes = yield call(api.getDailyQuest);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const lastClosedModalData = JSON.parse(localStorage.getItem("dailyQuestModalClosed")) || {};
    const hasWatchedQuest =
      lastClosedModalData.clientId === localStorage.getItem("clientId") &&
      lastClosedModalData.profileId === localStorage.getItem("profileId") &&
      new Date(lastClosedModalData.date).getTime() === today.getTime();
    if (questRes.status === 200 && questRes.data && questRes.data.dailyQuest && !hasWatchedQuest) {
      yield put(dailyQuestActions.getDailyQuestSuccess(questRes.data));
      yield put(dailyQuestActions.showDailyQuestModal());
    }
    resolve(questRes.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchGetDailyQuest() {
  while (true) {
    const action = yield take(GET_DAILY_QUEST_REQUEST);
    yield* asyncGetDailyQuest(action);
  }
}

export function* asyncAnswerDailyQuest({ payload, resolve, reject }) {
  try {
    const response = yield call(api.answerQuest, payload);
    if (response.status === 200 && response.data) {
      yield put(dailyQuestActions.answerDailyQuestSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchAnswerDailyQuest() {
  while (true) {
    const action = yield take(ANSWER_DAILY_QUEST_REQUEST);
    yield* asyncAnswerDailyQuest(action);
  }
}

export default function* () {
  yield all([fork(watchGetDailyQuest), fork(watchAnswerDailyQuest)]);
}
